import { styled } from '@mui/system';
import { Paper } from '@mui/material';

export const AccountTypeContainer = styled(Paper)(({ theme }) => ({
  display: 'inline-block',
  boxShadow: '0px 6px 28px 5px rgba(66, 17, 207, 0.3)',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  width: '9rem',
  height: '9.8rem',
  '.main-container': {
    marginTop: '1.6rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    'img': {
      width: '4rem',
      marginBottom: '10px'
    },
  },
  userSelect: 'none',
  cursor: 'pointer',
  ':nth-of-type(1)': {
    marginRight: '2rem'
  },
  transition: '0.3s all ease-in-out',
  '&.selected': {
    backgroundColor: theme.palette.common.white,
    '.user-type-text': {
      display: 'none'
    },
    width: '64px',
    height: '64px',
    '.main-container': {
      marginTop: '14px',
      'img': {
        width: '2.3rem',
        marginBottom: '0'
      }
    },
    ':nth-of-type(1)': {
      marginRight: '1rem'
    },
    border: '1px solid rgba(201, 201, 201, 1)',
    boxShadow: 'none',
    cursor: 'inherit'
  },
  [theme.breakpoints.down(1025)]: {
    '.main-container': {
      'img': {
        width: '2.6rem',
        marginBottom: '10px'
      },
      textAlign: 'center'
    },
    // height: '135px'
  }
}));
